var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticStyle: { display: "flex", margin: "10px" } },
      [
        _c("Y-button", {
          style: { fontSize: _vm.fonts },
          attrs: { button: _vm.addButton, size: _vm.addSize },
          on: { handleClickButton: _vm.handleClickButton }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "content",
        staticStyle: { display: "flex", "justify-content": "space-around" }
      },
      [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("Y-form", {
              ref: "forms",
              attrs: { form: _vm.columns, formData: _vm.formData, inline: "" },
              on: { handleSelect: _vm.handleSelect }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleChangeGroup },
                model: {
                  value: _vm.checkList,
                  callback: function($$v) {
                    _vm.checkList = $$v
                  },
                  expression: "checkList"
                }
              },
              _vm._l(_vm.checkListLabel, function(item, index) {
                return _c("el-checkbox", {
                  key: index,
                  style: { fontSize: _vm.fonts },
                  attrs: { label: item.label }
                })
              }),
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }